module.exports = __webpack_public_path__ + "static/media/call_type_offline.87229ca1.svg";